// 24-hour unlock window for the patient-data password gate (per Omer,
// 2026-08-16: ask for the password at most once every 24 hours).
// The unlock is scoped to the logged-in admin: a different USER_EMAIL in
// localStorage invalidates it immediately.
const KEY = "PATIENT_GATE_UNLOCK";
const WINDOW_MS = 24 * 60 * 60 * 1000;

export function isPatientGateUnlocked() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return false;
    const { email, at } = JSON.parse(raw);
    return (
      !!email &&
      email === localStorage.getItem("USER_EMAIL") &&
      typeof at === "number" &&
      Date.now() - at < WINDOW_MS
    );
  } catch {
    return false;
  }
}

export function markPatientGateUnlocked() {
  try {
    localStorage.setItem(
      KEY,
      JSON.stringify({ email: localStorage.getItem("USER_EMAIL"), at: Date.now() }),
    );
  } catch {
    // storage unavailable — fall back to session-only behavior
  }
}
